<template>
  <b-container :style="cssVars" class="body">
    <b-row>
      <b-col class="pt-3">
        <Event v-if="type_ && type_.trim().toUpperCase() == 'EVENT'" :event_id="parseInt(this.event_id)" :small="!!small" />        
        <Participants v-if="type_ && type_.trim().toUpperCase() == 'PARTICIPANTS'" :event_id="parseInt(this.event_id)" :showTeams="!!showTeams" />        
        <Teams v-if="type_ && type_.trim().toUpperCase() == 'TEAMS'" :event_id="parseInt(this.event_id)" :showParticipants="!!showParticipants" />        
        <RegisterForm v-if="type_ && type_.trim().toUpperCase() == 'REGISTER'" :event_id="parseInt(this.event_id)" showEventData showParticipants />        
        <div v-else>
          Komponente falsch eingebunden. Bitte geben Sie einen gültigen Wert für
          das Feld <strong>type</strong> an.
          <ul>
            <li><strong>EVENT</strong> Eventdaten (Parameter: small[boolean])</li>
            <li><strong>PARTICIPANTS</strong> Teilnehmerübersicht (Parameter: showTeams[boolean])</li>
            <li><strong>TEAMS</strong> Teamübersicht (Parameter: showParticipants[boolean])</li>
            <li><strong>REGISTER</strong> Registrierungs Formular </li>
          </ul>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import store from "./store";

export default {
  store,
  name: "WebComponentApp",
  components: {
    Event: () =>
      import(/* webpackChunkName: "wc-event" */ "@/views/wc/Event.vue"),  
    Participants: () =>
      import(/* webpackChunkName: "wc-participants" */ "@/views/wc/Participants.vue"), 
    Teams: () =>
      import(/* webpackChunkName: "wc-participants" */ "@/views/wc/Teams.vue"),  
    RegisterForm: () =>
      import(/* webpackChunkName: "wc-register" */ "@/views/wc/RegisterForm.vue"),    
  },
  props: {
    backendBaseUrl: {
      type: String,
      default: process.env.VUE_APP_API_BASE_URL,
    },
    type: {
      type: String,
      validator(val) {
        if (
          ![
            "EVENT",
            "PARTICIPANTS",
            "TEAMS",
            "REGISTER",
            null,
          ].includes(val)
        )
          return false;
        return true;
      },
      required: true,
    },
    // other props
    event_id: String,
    showTeams: Boolean,
    showParticipants: Boolean,
    small: Boolean,
    datenschutz_url: String,
  },
  data() {
    return {
      type_: this.type,
    };
  },
  computed: {
    cssVars() {
      return {
        "--accent-color": this.color,
      };
    },
  },
  async created() {
    this.$api.defaults.baseURL = this.backendBaseUrl;
    await this.$store.dispatch("startup");
  },
};
</script>

<style>
@import "bootstrap/dist/css/bootstrap.css";
@import "bootstrap-vue/dist/bootstrap-vue.css";
:root,
:host {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}
.body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}
.clickable {
  cursor: pointer;
}
/* .grecaptcha-badge {
  visibility: hidden;
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--accent-color) !important;
  background-color: var(--accent-color) !important;
}
.progress-bar {
  background-color: var(--accent-color) !important;
}
.border-primary {
  border-color: var(--accent-color) !important;
}
select:focus {
  border-color: var(--accent-color) !important;
  box-shadow: unset !important;
}
.custom-control-input:focus ~ .custom-control-label::before {
  border-color: var(--accent-color) !important;
  box-shadow: none !important;
}
input:focus {
  border-color: var(--accent-color) !important;
  box-shadow: unset !important;
} */
</style>